window.WCTableData = window.WCTableData || [];
window.WCTableData.push(
{
  "id": "focaccia-burrata-aperitivo",
  "priority": 1,
  "name": "FOCACCIA & BURRATA APERITIVO",
  "occasions": [
    "friends",
    "aperitivo",
    "spontaneous",
    "date"
  ],
  "totalTime": 15,
  "difficulty": 1,
  "vibes": [
    "mediterranean",
    "sharing",
    "fresh"
  ],
  "drinkCats": [
    "aperitivo",
    "wine",
    "beer",
    "open"
  ],
  "diet": "vegetarian",
  "lactoseLow": false,
  "budgetLow": 7,
  "budgetHigh": 10,
  "reason": "Warm, salzig, frisch und in einer Viertelstunde auf dem Tisch – genau richtig, wenn der Abend nicht in der Küche beginnen soll.",
  "food": "Warme Focaccia, marinierte Kirschtomaten & Burrata",
  "main": "Sharing Board in der Mitte – kein zweiter Gang nötig",
  "drink": "Basil Spritz",
  "naDrink": "Basil Citrus Soda",
  "tableDetail": "Eine große Platte in die Mitte. Focaccia reißen statt portionieren.",
  "prep": "10–15 Minuten",
  "hostTip": "Die Burrata erst ganz am Ende aufreißen. So bleibt die Platte frisch und sieht bewusst unperfekt aus.",
  "ingredients": [
    {
      "group": "produce",
      "name": "Cherrytomaten",
      "qty": 250,
      "unit": "g"
    },
    {
      "group": "produce",
      "name": "Bio-Zitrone",
      "qty": 1,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "produce",
      "name": "Basilikum",
      "qty": 20,
      "unit": "g"
    },
    {
      "group": "cooling",
      "name": "Burrata",
      "qty": 2,
      "unit": "Kugeln",
      "whole": true
    },
    {
      "group": "pantry",
      "name": "Focaccia",
      "qty": 1,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "pantry",
      "name": "Olivenöl",
      "qty": 45,
      "unit": "ml"
    },
    {
      "group": "pantry",
      "name": "Meersalz",
      "qty": 4,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Schwarzer Pfeffer",
      "qty": 1,
      "unit": "g"
    }
  ],
  "drinkIngredients": [
    {
      "group": "drinks",
      "name": "Aperitivo bitter",
      "qty": 160,
      "unit": "ml"
    },
    {
      "group": "drinks",
      "name": "Soda",
      "qty": 240,
      "unit": "ml"
    },
    {
      "group": "produce",
      "name": "Orange",
      "qty": 1,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "optional",
      "name": "Eis",
      "qty": 400,
      "unit": "g"
    }
  ],
  "naDrinkIngredients": [
    {
      "group": "drinks",
      "name": "Bitter-Aperitif alkoholfrei",
      "qty": 160,
      "unit": "ml"
    },
    {
      "group": "drinks",
      "name": "Soda",
      "qty": 240,
      "unit": "ml"
    },
    {
      "group": "produce",
      "name": "Orange",
      "qty": 1,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "optional",
      "name": "Eis",
      "qty": 400,
      "unit": "g"
    }
  ],
  "equipment": ["Backblech oder Airfryer", "große Servierplatte", "kleine Schüssel", "feine Reibe"],
  "makeAhead": "Tomaten bis zu 30 Minuten vorher marinieren. Focaccia und Burrata erst kurz vor dem Servieren warm machen beziehungsweise öffnen.",
  "serving": "Focaccia außen um die Platte legen, Burrata mittig öffnen und die Tomaten samt Dressing darübergeben.",
  "steps": [
    "Backofen auf 200 °C Ober-/Unterhitze vorheizen. Focaccia leicht mit insgesamt etwa 10 ml Olivenöl beträufeln.",
    "Focaccia 5–7 Minuten aufbacken, bis die Oberfläche warm und die Kanten leicht knusprig sind. Im Airfryer reichen meist 3–4 Minuten bei 180 °C.",
    "Tomaten halbieren. Mit dem restlichen Olivenöl, 1 TL fein abgeriebener Zitronenschale, Salz und Pfeffer mischen und 5 Minuten ziehen lassen.",
    "Basilikumblätter abzupfen; kleine Blätter ganz lassen, große grob zerreißen.",
    "Burrata abtropfen lassen, auf der Platte grob öffnen und leicht salzen. Tomaten mit dem gesamten Dressing darum verteilen.",
    "Warme Focaccia in große Stücke reißen, Basilikum darübergeben und sofort gemeinsam servieren."
  ],
  "drinkSteps": [
    "Vier große Gläser bis oben mit Eis füllen und je 40 ml Aperitivo hineingeben.",
    "Je 60 ml kaltes Soda aufgießen, einmal vorsichtig umrühren und mit einer dünnen Orangenscheibe sowie einem kleinen Basilikumblatt servieren."
  ],
  "naDrinkSteps": [
    "Vier große Gläser bis oben mit Eis füllen und je 40 ml alkoholfreien Bitter-Aperitif hineingeben.",
    "Je 60 ml kaltes Soda aufgießen, einmal vorsichtig umrühren und mit Orange servieren."
  ],
  "recipe": {
    "title": "WEEKEND RECIPE 002 · Focaccia & Burrata",
    "url": "/blogs/weekend-recipes/focaccia-burrata"
  }
},
{
  "id": "tomato-burrata-table",
  "priority": 2,
  "name": "THE TOMATO BURRATA TABLE",
  "occasions": [
    "friends",
    "aperitivo",
    "dinner",
    "spontaneous"
  ],
  "totalTime": 15,
  "difficulty": 1,
  "vibes": [
    "mediterranean",
    "sharing",
    "fresh"
  ],
  "drinkCats": [
    "wine",
    "aperitivo",
    "alcoholfree",
    "open"
  ],
  "diet": "vegetarian",
  "lactoseLow": false,
  "budgetLow": 8,
  "budgetHigh": 10,
  "reason": "Late Summer auf einer Platte: viel Tomate, cremige Burrata, warme Focaccia und ein Drink, der nicht mit dem Essen konkurriert.",
  "food": "Gemischte Tomaten, Burrata & Basilikum",
  "main": "Warme Focaccia zum Reißen und Teilen",
  "drink": "Chilled Rosé",
  "naDrink": "Sparkling Grape & Basil",
  "tableDetail": "Don’t plate it. Der Tisch ist der Teller.",
  "prep": "15 Minuten",
  "hostTip": "Die Tomaten fünf Minuten im Dressing ziehen lassen, bevor Burrata und Brot dazukommen.",
  "ingredients": [
    {
      "group": "produce",
      "name": "Gemischte Tomaten",
      "qty": 1000,
      "unit": "g"
    },
    {
      "group": "produce",
      "name": "Basilikum",
      "qty": 25,
      "unit": "g"
    },
    {
      "group": "produce",
      "name": "Knoblauch",
      "qty": 1,
      "unit": "Zehe",
      "whole": true
    },
    {
      "group": "cooling",
      "name": "Burrata",
      "qty": 2,
      "unit": "Kugeln",
      "whole": true
    },
    {
      "group": "pantry",
      "name": "Focaccia",
      "qty": 250,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Olivenöl",
      "qty": 60,
      "unit": "ml"
    },
    {
      "group": "pantry",
      "name": "Balsamico",
      "qty": 30,
      "unit": "ml"
    },
    {
      "group": "pantry",
      "name": "Honig",
      "qty": 7,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Meersalz",
      "qty": 4,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Schwarzer Pfeffer",
      "qty": 1,
      "unit": "g"
    }
  ],
  "drinkIngredients": [
    {
      "group": "drinks",
      "name": "Trockener Rosé",
      "qty": 600,
      "unit": "ml"
    }
  ],
  "naDrinkIngredients": [
    {
      "group": "drinks",
      "name": "Alkoholfreier Sparkling Grape",
      "qty": 600,
      "unit": "ml"
    },
    {
      "group": "produce",
      "name": "Basilikum",
      "qty": 8,
      "unit": "g"
    }
  ],
  "equipment": ["große Servierplatte", "Schüssel", "Schneebesen", "Backblech oder Airfryer"],
  "makeAhead": "Dressing und geschnittene Tomaten können 20 Minuten vorher vorbereitet werden. Erst 5–10 Minuten vor dem Essen vermischen.",
  "serving": "Tomaten flach verteilen, Burrata nicht vollständig vermengen und warmes Brot separat dazustellen.",
  "steps": [
    "Tomaten waschen und je nach Größe halbieren, vierteln oder in dicke Scheiben schneiden. Auf einer großen Platte verteilen.",
    "Olivenöl, Balsamico, Honig, fein geriebenen Knoblauch, Salz und Pfeffer gründlich verrühren, bis sich das Dressing leicht verbindet.",
    "Dressing über die Tomaten geben, vorsichtig wenden und 5 Minuten bei Raumtemperatur ziehen lassen.",
    "Focaccia bei 200 °C 5–7 Minuten erwärmen und anschließend in grobe Stücke schneiden oder reißen.",
    "Burrata abtropfen lassen, auf den Tomaten öffnen und nur leicht mit dem Tomatendressing überziehen.",
    "Basilikum kurz vor dem Servieren darüberzupfen, final mit Salz und Pfeffer abschmecken und die warme Focaccia dazustellen."
  ],
  "drinkSteps": [
    "Rosé mindestens 2 Stunden auf 8–10 °C vorkühlen.",
    "Je etwa 150 ml einschenken, sobald die Platte serviert ist; die Flasche anschließend wieder kühl stellen."
  ],
  "naDrinkSteps": [
    "Sparkling Grape vollständig vorkühlen.",
    "Je ein kleines Basilikumblatt zwischen den Händen anschlagen, ins Glas geben und mit etwa 150 ml Sparkling Grape auffüllen."
  ],
  "recipe": {
    "title": "WEEKEND RECIPE 003 · The Tomato Burrata Table",
    "url": "/blogs/weekend-recipes/tomato-burrata-table"
  }
},
{
  "id": "grilled-peach-table",
  "priority": 3,
  "name": "THE GRILLED PEACH TABLE",
  "occasions": [
    "date",
    "friends",
    "aperitivo",
    "dinner"
  ],
  "totalTime": 20,
  "difficulty": 1,
  "vibes": [
    "mediterranean",
    "sharing",
    "fresh",
    "surprise"
  ],
  "drinkCats": [
    "wine",
    "aperitivo",
    "cocktail",
    "open"
  ],
  "diet": "vegetarian",
  "lactoseLow": false,
  "budgetLow": 9,
  "budgetHigh": 12,
  "reason": "Süß, salzig, warm und knusprig – ein kleiner Hosting-Moment, der deutlich aufwendiger wirkt als er ist.",
  "food": "Gegrillte Pfirsiche, Feta, Honig & Pistazien",
  "main": "Geröstetes Sauerteigbrot zum Teilen",
  "drink": "Peach Wine Spritz",
  "naDrink": "Peach & Tonic",
  "tableDetail": "Eine Platte, viele Hände, keine Einzelportionen.",
  "prep": "20 Minuten",
  "hostTip": "Pfirsiche erst in die wirklich heiße Pfanne legen. Farbe ist hier Geschmack.",
  "ingredients": [
    {
      "group": "produce",
      "name": "Reife Pfirsiche",
      "qty": 4,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "produce",
      "name": "Bio-Zitrone",
      "qty": 1,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "produce",
      "name": "Basilikum",
      "qty": 20,
      "unit": "g"
    },
    {
      "group": "cooling",
      "name": "Feta",
      "qty": 200,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Sauerteigbrot",
      "qty": 8,
      "unit": "Scheiben",
      "whole": true
    },
    {
      "group": "pantry",
      "name": "Olivenöl",
      "qty": 45,
      "unit": "ml"
    },
    {
      "group": "pantry",
      "name": "Honig",
      "qty": 25,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Pistazien",
      "qty": 35,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Meersalz",
      "qty": 3,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Schwarzer Pfeffer",
      "qty": 1,
      "unit": "g"
    }
  ],
  "drinkIngredients": [
    {
      "group": "drinks",
      "name": "Trockener Weißwein",
      "qty": 400,
      "unit": "ml"
    },
    {
      "group": "drinks",
      "name": "Soda",
      "qty": 200,
      "unit": "ml"
    }
  ],
  "naDrinkIngredients": [
    {
      "group": "drinks",
      "name": "Tonic Water",
      "qty": 600,
      "unit": "ml"
    },
    {
      "group": "produce",
      "name": "Pfirsich",
      "qty": 1,
      "unit": "Stk.",
      "whole": true
    }
  ],
  "equipment": ["Grillpfanne oder Grill", "kleine Pfanne", "Servierplatte", "feine Reibe"],
  "makeAhead": "Pistazien vorab rösten und hacken. Pfirsiche erst direkt vor dem Servieren grillen, damit sie warm bleiben.",
  "serving": "Warme Pfirsiche als Mittelpunkt anrichten; Brot separat legen, damit es knusprig bleibt.",
  "steps": [
    "Pfirsiche halbieren, entsteinen und die Schnittflächen dünn mit etwa 10 ml Olivenöl bestreichen.",
    "Grill oder Grillpfanne stark erhitzen. Pfirsiche mit der Schnittfläche nach unten 3–4 Minuten rösten, ohne sie zu bewegen; dann 1 Minute auf der Hautseite erwärmen.",
    "Pistazien in einer trockenen Pfanne 2 Minuten rösten, abkühlen lassen und grob hacken.",
    "Sauerteigbrot mit etwa 20 ml Olivenöl bestreichen und pro Seite 2–3 Minuten rösten, bis deutliche Röststellen entstehen.",
    "Pfirsiche auf einer Platte anrichten, Feta darüberbröseln und Honig in dünnen Linien darübergeben.",
    "Mit Pistazien, Basilikum, 1 TL Zitronenabrieb, einer Prise Salz und schwarzem Pfeffer abschließen; Brot direkt dazu servieren."
  ],
  "drinkSteps": [
    "Vier Weingläser mit Eis füllen und je 100 ml gut gekühlten Weißwein hineingeben.",
    "Je 50 ml Soda aufgießen, einmal rühren und mit einer dünnen Pfirsichspalte servieren."
  ],
  "naDrinkSteps": [
    "Pfirsich in sehr dünne Spalten schneiden und auf vier eisgefüllte Gläser verteilen.",
    "Je 150 ml kaltes Tonic langsam aufgießen und sofort servieren."
  ],
  "recipe": {
    "title": "WEEKEND RECIPE 004 · The Grilled Peach Table",
    "url": "/blogs/weekend-recipes/grilled-peach-table"
  }
},
{
  "id": "sage-lemon-aperitivo",
  "priority": 4,
  "name": "SAGE LEMON APERITIVO",
  "occasions": [
    "aperitivo",
    "friends",
    "spontaneous",
    "date"
  ],
  "totalTime": 15,
  "difficulty": 1,
  "vibes": [
    "mediterranean",
    "sharing",
    "fresh"
  ],
  "drinkCats": [
    "cocktail",
    "aperitivo",
    "alcoholfree",
    "open"
  ],
  "diet": "vegetarian",
  "lactoseLow": true,
  "budgetLow": 10,
  "budgetHigh": 15,
  "reason": "Der Drink steht im Mittelpunkt, aber Oliven, Crostini und Zitrone machen daraus einen echten Aperitivo statt nur eine Runde Getränke.",
  "food": "Zitronen-Crostini & marinierte Oliven",
  "main": "Aperitivo Board mit Kräutern und warmem Brot",
  "drink": "Sage Lemon Spritz",
  "naDrink": "Sage Lemon Spritz 0.0",
  "tableDetail": "Kleine Schalen, ein Brett, keine Servierfolge.",
  "prep": "15 Minuten",
  "hostTip": "Salbei einmal zwischen den Händen anschlagen – das reicht für Aroma, ohne den Drink bitter zu machen.",
  "ingredients": [
    {
      "group": "produce",
      "name": "Bio-Zitrone",
      "qty": 2,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "produce",
      "name": "Salbei",
      "qty": 12,
      "unit": "Blätter",
      "whole": true
    },
    {
      "group": "pantry",
      "name": "Baguette",
      "qty": 240,
      "unit": "g"
    },
    {
      "group": "cooling",
      "name": "Frischkäse laktosearm",
      "qty": 160,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Grüne Oliven",
      "qty": 200,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Olivenöl",
      "qty": 25,
      "unit": "ml"
    },
    {
      "group": "pantry",
      "name": "Meersalz",
      "qty": 3,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Schwarzer Pfeffer",
      "qty": 1,
      "unit": "g"
    }
  ],
  "drinkIngredients": [
    {
      "group": "drinks",
      "name": "Gin",
      "qty": 120,
      "unit": "ml"
    },
    {
      "group": "produce",
      "name": "Zitronensaft",
      "qty": 80,
      "unit": "ml"
    },
    {
      "group": "drinks",
      "name": "Salbeisirup",
      "qty": 60,
      "unit": "ml"
    },
    {
      "group": "drinks",
      "name": "Trockener Sekt",
      "qty": 240,
      "unit": "ml"
    },
    {
      "group": "drinks",
      "name": "Soda",
      "qty": 160,
      "unit": "ml"
    },
    {
      "group": "optional",
      "name": "Eis",
      "qty": 400,
      "unit": "g"
    }
  ],
  "naDrinkIngredients": [
    {
      "group": "drinks",
      "name": "Gin-Alternative 0.0",
      "qty": 120,
      "unit": "ml"
    },
    {
      "group": "produce",
      "name": "Zitronensaft",
      "qty": 80,
      "unit": "ml"
    },
    {
      "group": "drinks",
      "name": "Salbeisirup",
      "qty": 60,
      "unit": "ml"
    },
    {
      "group": "drinks",
      "name": "Sparkling Tea 0.0",
      "qty": 240,
      "unit": "ml"
    },
    {
      "group": "drinks",
      "name": "Soda",
      "qty": 160,
      "unit": "ml"
    },
    {
      "group": "optional",
      "name": "Eis",
      "qty": 400,
      "unit": "g"
    }
  ],
  "equipment": ["Backblech", "Schüssel", "kleine Pfanne", "feine Reibe", "vier große Gläser"],
  "makeAhead": "Frischkäsecreme und Oliven können bis zu 2 Stunden vorher vorbereitet und kalt gestellt werden. Brot erst kurz vor Ankunft rösten.",
  "serving": "Crostini auf ein Brett, Oliven in eine flache Schale und Drinks daneben – keine feste Reihenfolge nötig.",
  "steps": [
    "Backofen auf 200 °C Ober-/Unterhitze vorheizen. Baguette schräg in etwa 1,5 cm dicke Scheiben schneiden.",
    "Brotscheiben mit der Hälfte des Olivenöls bestreichen und 6–8 Minuten rösten, nach der Hälfte einmal wenden.",
    "Frischkäse mit 1 TL fein abgeriebener Zitronenschale, 1 TL Zitronensaft, Pfeffer und einer Prise Salz glatt rühren.",
    "Oliven mit restlichem Olivenöl, zwei breiten Streifen Zitronenschale und vier fein geschnittenen Salbeiblättern in einer kleinen Pfanne 3 Minuten lauwarm ziehen lassen.",
    "Frischkäsecreme auf die warmen Crostini streichen und mit etwas Pfeffer abschließen.",
    "Crostini und lauwarme Oliven auf Brett und Schale verteilen; übrige Salbeiblätter für die Drinks bereitlegen."
  ],
  "drinkSteps": [
    "Vier große Gläser mit Eis füllen. Je 30 ml Gin, 20 ml Zitronensaft und 15 ml Salbeisirup hineingeben und 5 Sekunden rühren.",
    "Je 60 ml Sekt und 40 ml Soda langsam aufgießen.",
    "Je ein Salbeiblatt zwischen den Händen anschlagen, mit einer Zitronenzeste ins Glas geben und vor dem Servieren einmal vorsichtig heben."
  ],
  "naDrinkSteps": [
    "Vier große Gläser mit Eis füllen. Je 30 ml 0.0-Gin, 20 ml Zitronensaft und 15 ml Salbeisirup hineingeben und kurz rühren.",
    "Je 60 ml Sparkling Tea und 40 ml Soda langsam aufgießen.",
    "Mit angeschlagenem Salbei und Zitronenzeste aromatisieren und sofort servieren."
  ],
  "recipe": {
    "title": "WEEKEND RECIPE 001 · Sage Lemon Spritz",
    "url": "/blogs/weekend-recipes/sage-lemon-spritz"
  }
},
{
  "id": "amalfi-lemon-pasta",
  "priority": 5,
  "name": "AMALFI LEMON PASTA TABLE",
  "occasions": [
    "date",
    "dinner",
    "friends"
  ],
  "totalTime": 30,
  "difficulty": 2,
  "vibes": [
    "mediterranean",
    "comfort",
    "fresh"
  ],
  "drinkCats": [
    "wine",
    "aperitivo",
    "alcoholfree",
    "open"
  ],
  "diet": "vegetarian",
  "lactoseLow": false,
  "budgetLow": 11,
  "budgetHigh": 16,
  "reason": "Cremige Zitrone, viel Pfeffer und ein großer Pastatopf zum Teilen – Dinner-Gefühl ohne Drei-Gänge-Stress.",
  "food": "Fenchel-Zitronen-Salat",
  "main": "Pasta al Limone mit Parmesan",
  "drink": "Limoncello Highball",
  "naDrink": "Lemon Rosemary Highball 0.0",
  "tableDetail": "Pasta direkt in einer warmen Servierschüssel auf den Tisch.",
  "prep": "30 Minuten",
  "hostTip": "Etwas Pastawasser zurückhalten und die Sauce erst kurz vor dem Servieren final emulgieren.",
  "ingredients": [
    {
      "group": "produce",
      "name": "Bio-Zitrone",
      "qty": 2,
      "unit": "Stk.",
      "whole": true
    },
    {
      "group": "produce",
      "name": "Fenchel",
      "qty": 1,
      "unit": "Knolle",
      "whole": true
    },
    {
      "group": "produce",
      "name": "Petersilie",
      "qty": 20,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Spaghetti",
      "qty": 360,
      "unit": "g"
    },
    {
      "group": "cooling",
      "name": "Parmesan",
      "qty": 120,
      "unit": "g"
    },
    {
      "group": "cooling",
      "name": "Butter",
      "qty": 70,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Olivenöl",
      "qty": 30,
      "unit": "ml"
    },
    {
      "group": "pantry",
      "name": "Meersalz",
      "qty": 6,
      "unit": "g"
    },
    {
      "group": "pantry",
      "name": "Schwarzer Pfeffer",
      "qty": 2,
      "unit": "g"
    }
  ],
  "drinkIngredients": [
    {
      "group": "drinks",
      "name": "Limoncello",
      "qty": 160,
      "unit": "ml"
    },
    {
      "group": "drinks",
      "name": "Soda",
      "qty": 440,
      "unit": "ml"
    },
    {
      "group": "optional",
      "name": "Eis",
      "qty": 400,
      "unit": "g"
    }
  ],
  "naDrinkIngredients": [
    {
      "group": "drinks",
      "name": "Soda",
      "qty": 560,
      "unit": "ml"
    },
    {
      "group": "drinks",
      "name": "Zitronensirup",
      "qty": 80,
      "unit": "ml"
    },
    {
      "group": "produce",
      "name": "Rosmarin",
      "qty": 4,
      "unit": "Zweige",
      "whole": true
    },
    {
      "group": "optional",
      "name": "Eis",
      "qty": 400,
      "unit": "g"
    }
  ],
  "equipment": ["großer Topf", "große Pfanne", "feiner Hobel", "Zange", "feine Reibe"],
  "makeAhead": "Fenchelsalat bis zu 30 Minuten vorher vorbereiten. Parmesan reiben und Zitronen abreiben, bevor die Pasta ins Wasser kommt.",
  "serving": "Pasta in einer vorgewärmten Schüssel servieren; Fenchelsalat separat reichen, damit er knackig bleibt.",
  "steps": [
    "Fenchel sehr fein hobeln. Mit Petersilie, 15 ml Olivenöl, 1 EL Zitronensaft und einer Prise Salz mischen und beiseitestellen.",
    "Parmesan fein reiben. Von beiden Zitronen die Schale abreiben und anschließend etwa 50 ml Saft auspressen.",
    "Spaghetti in reichlich gesalzenem Wasser 2 Minuten kürzer als auf der Packung angegeben kochen. Vor dem Abgießen mindestens 300 ml Kochwasser sichern.",
    "Butter in einer großen Pfanne bei niedriger Hitze schmelzen. Zitronenabrieb, 150 ml Kochwasser und die noch bissfeste Pasta zugeben.",
    "Pasta 1–2 Minuten schwenken. Pfanne vom Herd ziehen, Parmesan portionsweise einarbeiten und nach Bedarf weiteres Kochwasser ergänzen, bis eine glänzende Sauce entsteht.",
    "Zitronensaft nach Geschmack, viel schwarzen Pfeffer und Salz zugeben. Sofort in der warmen Schüssel mit dem Fenchelsalat servieren."
  ],
  "drinkSteps": [
    "Vier Highball-Gläser bis oben mit Eis füllen und je 40 ml Limoncello hineingeben.",
    "Je 110 ml sehr kaltes Soda aufgießen, einmal vorsichtig rühren und mit Zitronenzeste servieren."
  ],
  "naDrinkSteps": [
    "Vier Highball-Gläser mit Eis füllen und je 20 ml Zitronensirup hineingeben.",
    "Je 140 ml Soda aufgießen. Rosmarinzweige zwischen den Händen anschlagen, kurz ins Glas geben und einmal rühren."
  ]
}
);
